import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=33ba8d49&scoped=true&lang=pug"
import script from "./RichText.vue?vue&type=script&lang=js"
export * from "./RichText.vue?vue&type=script&lang=js"
import style0 from "./RichText.vue?vue&type=style&index=0&id=33ba8d49&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ba8d49",
  null
  
)

export default component.exports